import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { subscribeGlobalLoading, resetGlobalLoading } from '@/api/globalLoading';
import { GlobalLoadingOverlay } from '@/components/ui/GlobalLoadingOverlay';

/**
 * Full-screen loader while axiosClient has pending requests.
 */
export function GlobalLoadingProvider({ children }) {
  const [pendingCount, setPendingCount] = useState(0);
  const active = pendingCount > 0;

  useEffect(() => {
    // Clear any stuck count from HMR / mismatched start-end after dedupe bugs.
    resetGlobalLoading();
    return subscribeGlobalLoading(setPendingCount);
  }, []);

  useEffect(() => {
    if (!active) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);

  return (
    <>
      {children}
      {active && typeof document !== 'undefined'
        ? createPortal(<GlobalLoadingOverlay />, document.body)
        : null}
    </>
  );
}
